export default __webpack_public_path__ + "static/media/person4.14ae8e58.png";